import React from 'react'
import '../../styles/hero-section.css'
import ButtonCard from '../reusables/ButtonCard'

const HeroSection = () => {
  return (
    <>
      <div className='hero-section-main-container'>
        <div className='hero-sec-container'>
          <section className='hero-sec-content'>
            <p className='ai-platform'>Ai platform</p>
            <h1>AI enabled cognitive knowledge exchange platform.</h1>
            <p>Connecting problems to solutions.</p>
            <ButtonCard content='Sign up now' />
          </section>
          <section className='hero-sec-image'>
            <div className='overlay-div'>
              {/* <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'>
                <path
                  fill='#57E9F3'
                  fillOpacity='.4'
                  d='M0,128L30,138.7C60,149,120,171,180,192C240,213,300,235,360,213.3C420,192,480,128,540,106.7C600,85,660,107,720,112C780,117,840,107,900,90.7C960,75,1020,53,1080,69.3C1140,85,1200,139,1260,138.7C1320,139,1380,85,1410,58.7L1440,32L1440,320L1410,320C1380,320,1320,320,1260,320C1200,320,1140,320,1080,320C1020,320,960,320,900,320C840,320,780,320,720,320C660,320,600,320,540,320C480,320,420,320,360,320C300,320,240,320,180,320C120,320,60,320,30,320L0,320Z'
                ></path>
              </svg> */}
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default HeroSection
